export const translations = {
  en: {
    nav: {
      services: "Services",
      why: "Why Nevada",
      serve: "Who We Serve",
      process: "How We Help",
      about: "About KOAM",
      contact: "Contact",
      cta: "Book a Consultation",
    },
    hero: {
      eyebrow: "KOAM Las Vegas Business Consultants LLC",
      lines: ["Your Trusted Gateway", "to Business Success", "in Nevada & the United States"],
      sub: "We help Korean and international companies, entrepreneurs, and investors enter, establish, and grow their business in Nevada and across the United States — with a trusted bilingual partner on the ground in Las Vegas.",
      primaryCta: "Book a Free Consultation",
      secondaryCta: "Explore Our Services",
      badge: "Las Vegas, Nevada · KOAMNV.com",
      scroll: "Scroll",
    },
    marquee: ["Connecting Korea.", "Navigating America.", "Building Success."],
    why: {
      eyebrow: "Why Nevada",
      title: "America's most business-friendly state.",
      sub: "Four reasons global companies choose Nevada as their U.S. home base.",
      chapters: [
        {
          num: "01",
          title: "Zero State Income Tax",
          body: "Nevada levies no corporate income tax, no personal income tax, and no franchise tax. More of what your business earns stays in your business.",
        },
        {
          num: "02",
          title: "Strategic Western Gateway",
          body: "One-day reach to California and the major West Coast markets, without West Coast costs. Las Vegas sits at the crossroads of U.S. logistics.",
        },
        {
          num: "03",
          title: "Fast, Business-First Climate",
          body: "Rapid incorporation, strong asset-protection laws, light regulation, and a state government that actively courts international investment.",
        },
        {
          num: "04",
          title: "Where the World Meets",
          body: "Las Vegas hosts the world's largest trade shows and conventions — an unmatched stage to launch your brand and meet American buyers face to face.",
        },
      ],
    },
    services: {
      eyebrow: "What We Do",
      title: "Core Business Navigation Services",
      sub: "End-to-end guidance for your U.S. journey — from first idea to operating business.",
      items: [
        {
          title: "U.S. Market Entry Strategy",
          body: "Feasibility analysis, market positioning, and a practical go-to-market roadmap tailored to Korean and international companies.",
        },
        {
          title: "Business Formation & Registration",
          body: "Entity selection (LLC, C-Corp), Nevada incorporation, EIN, state and local licensing — set up correctly from day one.",
        },
        {
          title: "Regulatory & Government Navigation",
          body: "Plain-language guidance through U.S. federal, Nevada state, and local requirements so nothing gets lost in translation.",
        },
        {
          title: "Banking, Tax & Legal Coordination",
          body: "Warm introductions to vetted U.S. banks, CPAs, and attorneys experienced with foreign-owned businesses.",
        },
        {
          title: "Partnerships & Local Networking",
          body: "Connections to chambers of commerce, Korean-American networks, suppliers, and distribution partners in Nevada and beyond.",
        },
        {
          title: "Trade Show & Convention Support",
          body: "On-the-ground representation at Las Vegas exhibitions — booth coordination, buyer meetings, and bilingual interpretation.",
        },
      ],
    },
    serve: {
      eyebrow: "Who We Serve",
      title: "Built for those crossing the Pacific.",
      groups: [
        {
          title: "Korean Companies",
          body: "Established Korean businesses entering the U.S. market — from manufacturing and F&B to beauty, tech, and distribution.",
        },
        {
          title: "Entrepreneurs & Startups",
          body: "Founders launching a U.S. venture who need a trusted local partner to move fast and avoid costly mistakes.",
        },
        {
          title: "Investors & Family Offices",
          body: "Korean and international investors exploring Nevada opportunities in business, real estate, and hospitality.",
        },
      ],
    },
    process: {
      eyebrow: "How KOAM Helps",
      title: "A clear path, walked together.",
      steps: [
        {
          num: "Step 1",
          title: "Discovery Consultation",
          body: "A free, no-pressure conversation — in English or Korean — to understand your goals and assess your U.S. readiness.",
        },
        {
          num: "Step 2",
          title: "Tailored Roadmap",
          body: "A concrete plan covering entity setup, timeline, budget, and the exact sequence of steps for your Nevada launch.",
        },
        {
          num: "Step 3",
          title: "Execution & Setup",
          body: "We coordinate formation, licensing, banking, and local partners — keeping you informed at every milestone.",
        },
        {
          num: "Step 4",
          title: "Ongoing Partnership",
          body: "Continued advisory, representation, and network access as your U.S. business grows.",
        },
      ],
    },
    about: {
      eyebrow: "About KOAM",
      title: "A bridge between Korea and America, anchored in Las Vegas.",
      p1: "KOAM Las Vegas Business Consultants LLC is a bilingual, bicultural consulting firm headquartered in Las Vegas, Nevada. We exist for one purpose: to make doing business in the United States clear, credible, and achievable for Korean and international companies.",
      p2: "Our name carries our promise — Connecting Korea. Navigating America. Building Success. We combine deep local knowledge of Nevada's business landscape with the language, culture, and business etiquette our clients call home.",
      stats: [
        { value: "EN · 한국어", label: "Fully bilingual team" },
        { value: "Las Vegas, NV", label: "Headquarters" },
        { value: "KR ↔ US", label: "Cross-border focus" },
      ],
    },
    contact: {
      eyebrow: "Start the Conversation",
      title: "Book your free consultation.",
      sub: "Tell us about your business goals. We reply within one business day — in English or Korean, whichever you prefer.",
      emailLabel: "Email",
      locationLabel: "Location",
      location: "Las Vegas, Nevada, USA",
      domainLabel: "Website",
      name: "Full Name",
      company: "Company (optional)",
      email: "Email Address",
      phone: "Phone (optional)",
      type: "Inquiry Type",
      types: ["U.S. Market Entry", "Business Formation", "Investment & Real Estate", "Trade Show / Convention", "Other"],
      message: "How can we help?",
      namePh: "Your name",
      companyPh: "Company or organization",
      emailPh: "you@company.com",
      phonePh: "+82 or +1 ...",
      messagePh: "Tell us briefly about your business and what you would like to achieve in the U.S.",
      submit: "Send Consultation Request",
      sending: "Sending…",
      success: "Request received. We will reply within one business day.",
      error: "Something went wrong. Please email us directly at hello@koamnv.com.",
    },
    footer: {
      tagline: "Connecting Korea. Navigating America. Building Success.",
      explore: "Explore",
      contact: "Contact",
      rights: "© 2026 KOAM Las Vegas Business Consultants LLC. All rights reserved.",
      admin: "Admin",
    },
    admin: {
      title: "Lead Inbox",
      sub: "Enter the admin token to view consultation requests.",
      tokenPh: "Admin token",
      view: "View Leads",
      empty: "No leads yet.",
      unauthorized: "Invalid token.",
      refresh: "Refresh",
      back: "Back to site",
    },
  },
  ko: {
    nav: {
      services: "서비스",
      why: "왜 네바다인가",
      serve: "주요 고객",
      process: "지원 절차",
      about: "KOAM 소개",
      contact: "문의",
      cta: "상담 예약",
    },
    hero: {
      eyebrow: "코암 라스베가스 비즈니스 컨설턴츠",
      lines: ["네바다와 미국 전역,", "비즈니스 성공을 향한", "가장 믿음직한 관문"],
      sub: "한국 및 글로벌 기업, 기업가, 투자자가 네바다와 미국 전역에서 비즈니스를 시작하고 성장할 수 있도록, 라스베가스 현지의 신뢰할 수 있는 이중언어 파트너가 함께합니다.",
      primaryCta: "무료 상담 예약하기",
      secondaryCta: "서비스 살펴보기",
      badge: "네바다주 라스베가스 · KOAMNV.com",
      scroll: "스크롤",
    },
    marquee: ["한국과 미국을 잇다.", "미국 시장을 항해하다.", "성공을 함께 만들다."],
    why: {
      eyebrow: "왜 네바다인가",
      title: "미국에서 가장 기업 친화적인 주.",
      sub: "글로벌 기업이 미국 거점으로 네바다를 선택하는 네 가지 이유.",
      chapters: [
        {
          num: "01",
          title: "주 소득세 제로",
          body: "네바다에는 법인 소득세, 개인 소득세, 프랜차이즈세가 없습니다. 기업이 벌어들인 이익이 온전히 기업에 남습니다.",
        },
        {
          num: "02",
          title: "미 서부 관문의 전략적 입지",
          body: "캘리포니아와 서부 주요 시장을 하루 생활권으로 연결하면서도, 서부 해안의 높은 비용 부담은 없습니다.",
        },
        {
          num: "03",
          title: "빠르고 기업 우선적인 환경",
          body: "신속한 법인 설립, 강력한 자산 보호 법률, 합리적인 규제, 그리고 해외 투자를 적극 환영하는 주 정부.",
        },
        {
          num: "04",
          title: "세계가 모이는 도시",
          body: "라스베가스는 세계 최대 규모의 전시회와 컨벤션이 열리는 무대입니다. 미국 바이어와 직접 만날 최고의 기회입니다.",
        },
      ],
    },
    services: {
      eyebrow: "주요 서비스",
      title: "핵심 비즈니스 내비게이션 서비스",
      sub: "첫 아이디어부터 사업 운영까지 — 미국 진출의 전 과정을 함께합니다.",
      items: [
        {
          title: "미국 시장 진출 전략",
          body: "시장성 분석, 포지셔닝, 그리고 한국 및 글로벌 기업에 맞춘 실질적인 시장 진출 로드맵을 수립합니다.",
        },
        {
          title: "법인 설립 및 등록",
          body: "법인 형태 선택(LLC, C-Corp), 네바다 법인 설립, EIN 발급, 주·시 라이선스까지 첫날부터 정확하게 세팅합니다.",
        },
        {
          title: "규제 및 행정 지원",
          body: "미 연방, 네바다 주, 지방 정부의 요구 사항을 알기 쉬운 언어로 안내해 드립니다.",
        },
        {
          title: "은행·세무·법률 전문가 연계",
          body: "외국인 소유 기업 경험이 풍부한 미국 은행, 회계사, 변호사를 검증된 네트워크로 연결해 드립니다.",
        },
        {
          title: "현지 파트너십 및 네트워킹",
          body: "상공회의소, 한인 네트워크, 공급사 및 유통 파트너 등 네바다와 미국 전역의 인맥을 연결합니다.",
        },
        {
          title: "전시회·컨벤션 지원",
          body: "라스베가스 전시회 현장 대행 — 부스 운영, 바이어 미팅, 영한 통역까지 지원합니다.",
        },
      ],
    },
    serve: {
      eyebrow: "주요 고객",
      title: "태평양을 건너는 분들을 위해.",
      groups: [
        {
          title: "미국 진출 한국 기업",
          body: "제조, 식품·음료, 뷰티, 기술, 유통 등 미국 시장에 진출하는 한국 기업을 지원합니다.",
        },
        {
          title: "기업가 및 스타트업",
          body: "미국에서 새로운 사업을 시작하는 창업가에게 믿을 수 있는 현지 파트너가 되어 드립니다.",
        },
        {
          title: "투자자 및 패밀리 오피스",
          body: "네바다의 사업, 부동산, 호스피탈리티 투자 기회를 탐색하는 한국 및 글로벌 투자자를 지원합니다.",
        },
      ],
    },
    process: {
      eyebrow: "지원 절차",
      title: "명확한 길을, 함께 걷습니다.",
      steps: [
        {
          num: "1단계",
          title: "무료 상담 및 진단",
          body: "영어 또는 한국어로 편하게 진행되는 무료 상담에서 목표를 파악하고 미국 진출 준비도를 점검합니다.",
        },
        {
          num: "2단계",
          title: "맞춤 로드맵 수립",
          body: "법인 설립, 일정, 예산, 그리고 네바다 진출의 구체적인 단계별 계획을 제시합니다.",
        },
        {
          num: "3단계",
          title: "설립 및 실행",
          body: "법인 설립, 라이선스, 은행 계좌, 현지 파트너 연결까지 모든 마일스톤을 함께 진행합니다.",
        },
        {
          num: "4단계",
          title: "지속적 동행",
          body: "미국 사업이 성장하는 동안 상시 자문, 현지 대표 서비스, 네트워크 접근을 계속 제공합니다.",
        },
      ],
    },
    about: {
      eyebrow: "KOAM 소개",
      title: "한국과 미국을 잇는 다리, 라스베가스에서.",
      p1: "코암 라스베가스 비즈니스 컨설턴츠(KOAM Las Vegas Business Consultants LLC)는 네바다주 라스베가스에 본사를 둔 이중언어·이중문화 컨설팅 firm입니다. 한국 및 글로벌 기업의 미국 비즈니스를 명확하고 신뢰할 수 있게 만드는 것, 그것이 저희의 단 하나의 목표입니다.",
      p2: "이름에 약속을 담았습니다 — 한국과 미국을 잇고, 미국 시장을 항해하며, 성공을 함께 만듭니다. 네바다 비즈니스 환경에 대한 깊은 현지 지식과 고객의 언어·문화·비즈니스 관행에 대한 이해를 결합합니다.",
      stats: [
        { value: "EN · 한국어", label: "완벽한 이중언어 팀" },
        { value: "라스베가스, NV", label: "본사" },
        { value: "KR ↔ US", label: "한미 크로스보더 전문" },
      ],
    },
    contact: {
      eyebrow: "대화를 시작하세요",
      title: "무료 상담을 예약하세요.",
      sub: "비즈니스 목표를 알려 주세요. 영어 또는 한국어 중 편하신 언어로 1영업일 이내에 회신드립니다.",
      emailLabel: "이메일",
      locationLabel: "위치",
      location: "미국 네바다주 라스베가스",
      domainLabel: "웹사이트",
      name: "성함",
      company: "회사명 (선택)",
      email: "이메일 주소",
      phone: "전화번호 (선택)",
      type: "문의 유형",
      types: ["미국 시장 진출", "법인 설립", "투자 및 부동산", "전시회·컨벤션", "기타"],
      message: "무엇을 도와드릴까요?",
      namePh: "성함을 입력해 주세요",
      companyPh: "회사 또는 조직명",
      emailPh: "you@company.com",
      phonePh: "+82 또는 +1 ...",
      messagePh: "비즈니스와 미국 진출 목표를 간략히 알려 주세요.",
      submit: "상담 신청 보내기",
      sending: "전송 중…",
      success: "문의가 접수되었습니다. 1영업일 이내에 회신드리겠습니다.",
      error: "오류가 발생했습니다. hello@koamnv.com으로 직접 이메일을 보내 주세요.",
    },
    footer: {
      tagline: "한국과 미국을 잇다. 미국을 항해하다. 성공을 만들다.",
      explore: "바로가기",
      contact: "연락처",
      rights: "© 2026 KOAM Las Vegas Business Consultants LLC. All rights reserved.",
      admin: "관리자",
    },
    admin: {
      title: "상담 신청함",
      sub: "관리자 토큰을 입력하면 상담 신청 내역을 볼 수 있습니다.",
      tokenPh: "관리자 토큰",
      view: "내역 보기",
      empty: "아직 접수된 문의가 없습니다.",
      unauthorized: "토큰이 올바르지 않습니다.",
      refresh: "새로고침",
      back: "사이트로 돌아가기",
    },
  },
};
